import { Button } from '../atoms';

interface FormActionsProps {
  submitLabel?: string;
  busyLabel?: string;
  cancelLabel?: string;
  onCancel?: () => void;
  busy?: boolean;
  disabled?: boolean;
}

/** Footer row for a form: Cancel on the left, the primary submit action on the right. */
export function FormActions({ submitLabel = 'Save', busyLabel = 'Saving…', cancelLabel = 'Cancel', onCancel, busy, disabled }: FormActionsProps) {
  return (
    <div className="flex items-center justify-end gap-2">
      {onCancel && (
        <Button type="button" variant="ghost" onClick={onCancel} disabled={busy}>
          {cancelLabel}
        </Button>
      )}
      <Button type="submit" variant="primary" disabled={busy || disabled}>
        {busy ? busyLabel : submitLabel}
      </Button>
    </div>
  );
}
